<template>
  <div v-loading="loading" class="authorize"></div>
</template>
<script>
import loginService from "@/interface/pages/Login/login";

export default {
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    this.singleSignOn();
  },
  methods: {
    singleSignOn() {
      console.log("singleSignOn");
      const idToken = localStorage.getItem("idToken");
      try {
        loginService
          .singleSignOn(this, {
            params: { idToken },
          })
          .then(
            function (resp) {
              var res = resp.data;
              console.log("res", res);
              if (res.code == "200") {
                this.initInfo(res.data);
              } else {
                this.$message.error(res.message);
                this.$router.push("/login");
              }
            }.bind(this)
          )
          .catch((reason) => {
            console.log('reason', reason);
            // this.$router.push("/login");
          });
      } catch (error) {
        console.log("error", error);
        // this.$router.push("/login");
      }
    },
    initInfo(data) {
      localStorage.setItem("userName", data.user_name);
      localStorage.setItem("userId", data.user_id);
      localStorage.setItem("token", data.token);
      localStorage.setItem("time_zone", data.time_zone);
      localStorage.setItem("subscriptionName", data.subscription_name);
      localStorage.setItem("subscriptionID", data.subscription_id);
      localStorage.setItem("userType", data.type);
      localStorage.setItem("email", data.email); 

      loginService
        .getUserMenu(this, {
          params: {
            userId: data.user_id,
          },
        })
        .then((menuRes) => {
          const menu = menuRes.data;
          localStorage.setItem("menu", JSON.stringify(menu.data));
          if (menu.data&&menu.data.length) {
            this.$router.push("/audience/userGroupList");
          } else {
            this.$router.push("/unSubscription");
          }
          this.$message.success("login success!", 1);
        });
    },
  },
};
</script>
<style scoped>
.authorize {
  height: 100%;
  width: 100%;
  min-height: 660px;
  overflow: hidden;
  position: relative;
  z-index: -1;
}
</style>
